// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cs-input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  outline: none;
  border: 1px solid #d5dce1;
}
.cs-input:hover {
  border-color: #a9b0b6;
}
.cs-input:focus {
  border-color: #148dfd;
  box-shadow: 0 0 2px #148dfd;
}
.cs-text {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.defaultColor {
  background: #148dfd;
  color: #fff;
}
.defaultTextColor {
  color: #148dfd;
}
.widget-settings-tabs-container {
  display: flex;
  margin: 5px 0 27px 0;
}
.status-list {
  display: flex;
  align-items: center;
  gap: 8px;
}
.list-icon-hid {
  visibility: hidden;
}
.offline-info-textarea::placeholder {
  color: #c5ced6;
  font-size: 14px;
  line-height: 18px;
}
.installChatBox {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 16px 24px;
  width: 100%;
}
.parInfo {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.parInfoStart {
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
}
.WidgetRoleAgentStatus {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 5px 5px 16px 5px;
  width: 100%;
}
.installInfoText {
  margin: 6px 0 0 0;
  line-height: 28px;
  font-size: 14px;
}
.settingsInfoTextTop {
  margin: 10.8px 0 0 0;
  line-height: 18px;
  font-size: 14px;
}
.settingsInfoText {
  margin: 18px 0 12px 0;
  line-height: 22px;
  font-size: 14px;
}
.Settings-Info-Container {
  display: flex;
  margin-top: 23px;
  gap: 8px;
}
.Settings-Info-Container-Secondary {
  display: flex;
  gap: 8px;
  width: 50%;
  margin-right: 8px;
  align-items: end;
}
.custom-color-picker {
  display: flex;
  gap: 8px;
  align-items: end;
}
.halfWidth {
  width: 50%;
}
.appearance-options {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.color-options {
  display: flex;
  gap: 8px;
  margin-top: 13px;
  cursor: pointer;
}
.settings-tab-button {
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #fff;
  border: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  height: 40px;
  cursor: pointer;
}
.settings-tab-button:not(:disabled):hover {
  background-color: #0077cc;

  outline: none;
}

.apply-button {
  min-width: 112px;
  /* margin-top: 23px; */
}
.check-button {
  min-width: 80px;
  /* margin-top: 22px; */
}
.banner-cancel-button {
  padding: 10px 20px;
  background: transparent;
  color: #405261;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid #d5dce1;
}
.banner-cancel-button :not(:disabled):hover {
  border: 1px solid #c5ced6 !important;
  background-color: transparent !important;

  outline: none;
}
.banner-save-button {
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
}
.invite-dev-button {
  min-width: 184px;
  background: transparent;
  color: #405261;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid #d5dce1;
}
.invite-dev-button:not(:disabled):hover {
  border: 1px solid #c5ced6;

  outline: none;
}
.installation-guide-button {
  min-width: 160px;
  background: transparent;
  color: #405261;
  font-weight: 500;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid #d5dce1;
}
.installation-guide-button:not(:disabled):hover {
  border: 1px solid #c5ced6;

  outline: none;
}
.copy-code-button {
  min-width: 120px;
  transition: opacity 0.3s ease;
}
.copy-code-button:active {
  opacity: 0.8;
}
.codeContainer {
  display: flex;
  font-family: monospace;
  font-size: 14px;
  padding: 10px;
  max-height: 280px;
  overflow-y: scroll;
}
.codeContainer::-webkit-scrollbar-track {
  background: transparent;
}
.codeContainer::scrollbar {
  background: transparent !important;
}
.gradientback {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) -9.78%,
    #fff 58.22%
  );
  opacity: 0.8;
  height: 80px;
  margin-top: -80px;
  width: 99%;
  margin-bottom: 2.2rem;
}
.codeContainer::-webkit-scrollbar-track {
  background: transparent;
}
.lineNumbers {
  padding-right: 10px;
  text-align: right;
  color: #148dfd;
  user-select: none;
}
.codeContent {
  /* white-space: pre; */
  color: #556575;
}
.lineNumber {
  line-height: 1.5;
}
.codeLine {
  line-height: 1.5;
}
.settings-logo-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.settings-logo-text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.settings-logo-requirements {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.sideSpacx {
  max-width: 112px;
}
.bottomSpacx {
  max-width: 113px;
}
.live-view-link {
  color: #148dfd;
  font-size: 14px;
}
.welcomeMsg {
  display: flex;
  margin-top: 23px;
  gap: 16px;
}
.showSettingsContainer {
  margin-top: 20px;
  margin-bottom: 1rem;
}
.preChatContainer {
  margin-top: 23px;
}
.Settings-Appearance-Container {
  margin-top: 20px;
}
.Settings-Appearance-Container-Secondary {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.Settings-Visibility-Container {
  margin-top: 22px;
}
.Settings-Visibility-Container-Secondary {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
}
.spacingInputs {
  width: 50%;
  display: flex;
  gap: 18px;
  margin-top: 6px;
}
.spacingUnits {
  margin-top: 18px;
  font-size: 14px;
  color: #405261;
}
.Settings-Language-Container {
  margin-top: 18px;
}
.label-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.form-name {
  margin-bottom: 8px;
}
.form-input-div {
  margin-top: 5px;
  border-radius: 8px;
  background: transparent;
  padding: 0.5rem;
  /* min-height: 1.5rem; */
  /* font-size: 0.875rem; */
  border: 1px solid rgb(216, 220, 222);
  width: 100%;
}
.input-spacing {
  margin-bottom: 10px;
}
.settingsInfo {
  width: 42%;
}
.installChat {
  margin-top: 29.2px;
}
.startChat {
  margin-top: 23px;
}
.Setting-Section-Logo {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 23px;
}
.custom-border {
  border-color: #d5dce1 !important; /* Custom border color */
}
.Settings-Line-Bottom {
  margin: 24px 0 20px 0;
  width: 100%;
  height: 1px;
  border: 1px solid #e5e9ec;
}
.Install-Line-Bottom {
  margin: 10px 0 0 0;
  width: 100%;
  height: 1px;
  border: 1px solid #e5e9ec;
}
.Settings-Line-Bottom-Welcome {
  margin: 34px 0;
  width: 100%;
  height: 1px;
  border: 1px solid #e5e9ec;
}
.Appearance-button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 56px;
  background: none;
  border: 1px solid #e5e9ec;
  border-radius: 8px;
  font-size: 14px;
}
.Appearance-button.active {
  background-color: #f3fbff;
  border: 1px solid #148dfd;
}
.margin-left {
  margin-left: 7px;
}
.margin-right {
  margin-right: 7px;
}
.custom-tab {
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  line-height: 18px;
  color: #405261;
  text-transform: none;
  border: none;
  background-color: transparent;
  outline: none;
  border-bottom: 1px solid transparent;
  margin-right: 20px; /* Space between tabs */
  border-radius: 4px 4px 0 0; /* Rounded corners at the top of the tabs */
  transition: background-color 0.3s, color 0.3s; /* Smooth transition effects */
}
.custom-tab.selected {
  color: #061522;
  font-weight: 500;
  border-bottom: 1px solid #1976d2;
}

.custom-tab-content {
  padding: 16px;
  border: 1px solid #e0e0e0; /* Border around the tab content */
  border-radius: 0 0 4px 4px; /* Rounded corners at the bottom of the content area */
}

.sidebar-widget-settings {
  border: 1px solid#E5E9EC;
  padding: 8px 15px;
  background: #f9fafa;
  border-radius: 8px;
  /* overflow-y: auto;
  overflow-x: hidden; */
  position: sticky;
  right: 0;
  top: 0;
}
.main-widget-settings {
  border: 1px solid#E5E9EC;
  /* max-width: 656px; */
  width: 72%;
  padding: 10px 23px;
  border-radius: 8px;
  height: fit-content;
  /* margin-bottom: 3rem; */
}
.previewOneCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 28vh;
}
.boxTop {
  height: 10vh;
}
.widgetLogo {
  max-height: 35px;
  border-radius: 50%;
}
.chatSnap {
  height: 10vh;
}
.preChatForm {
  padding: 1rem;
}
.sidebar-widget-settings-tab {
  margin-bottom: 10px;
}
.fillTxt {
  font-size: 0.7rem;
}
.startChatUser {
  margin-top: 10px;
}
@media screen and (max-width: 1280px) {
  .sidebar-widget-settings {
    height: calc(100vh - 13em);
    width: 28%;
  }
  .previewOneCenter {
    height: 24vh;
  }
  .fillTxt {
    display: none;
  }
  .preChatForm {
    padding: 0.5rem;
  }
  .welcomeText {
    font-size: 0.75rem;
    padding-bottom: 5px;
  }
  .form-input-div {
    font-size: 0.6rem;
  }
  .widgetSubtext {
    font-size: 0.6rem;
  }
  .input-main-message {
    font-size: 0.6rem;
  }
  .preChatBtn {
    font-size: 0.6rem;
  }
  .barText {
    font-size: 0.6rem;
  }
  .botMain {
    font-size: 0.75rem;
  }
  .botSub {
    font-size: 0.6rem;
  }
  .welcomeMesg {
    font-size: 0.6rem;
  }
  .input-icons-div img {
    width: 18px;
    height: 18px;
  }
  .bubble {
    width: 39px;
    height: 39px;
  }
  .bar {
    height: 39px;
  }
  .trademark {
    visibility: hidden;
    padding: 0.01rem;
  }
  .widgetLogo {
    max-height: 34px;
  }
  .req-label-form {
    font-size: 0.6rem;
  }
}
@media screen and (min-width: 1281px) and (max-height: 850px) {
  .sidebar-widget-settings {
    height: calc(100vh - 13em);
    width: 32%;
  }
  .previewOneCenter {
    height: 30vh;
  }
  .previewThreeCenter {
    height: 36vh !important;
  }
  .chatSnap {
    height: 12vh;
  }
  .welcomeText {
    font-size: 14px;
  }
  .form-input-div {
    font-size: 0.8rem;
  }
  .widgetSubtext {
    font-size: 14px;
  }
  .input-main-message {
    font-size: 0.75rem;
  }
  .preChatBtn {
    font-size: 0.8rem;
    min-height: 32px;
  }
  .trademark {
    height: 6vh;
    padding: 0.6rem;
  }
  .botMain {
    font-size: 0.9rem;
  }
  .botSub {
    font-size: 0.75rem;
  }
  .welcomeMesg {
    font-size: 0.75rem;
  }
  .input-icons-div img {
    width: 24px;
    height: 24px;
  }
  .bubble {
    width: 56px;
    height: 56px;
  }
  .bar {
    height: 56px;
  }
  .fillTxt {
    display: block;
  }
  .req-label-form {
    font-size: 0.6rem;
  }
}
@media screen and (max-width: 1430px) {
  .widgetSubtext {
    font-size: 0.6rem;
  }
  .custom-tab-sidebar {
    font-size: 12px;
  }
  .live-view-link {
    font-size: 12px;
  }
  .preChatBtn {
    padding: 0.45rem;
  }
}
@media screen and (min-width: 1430px) and (min-height: 850px) {
  .bubble {
    width: 56px;
    height: 56px;
  }
  .bar {
    height: 56px;
  }
  .input-icons-div img {
    width: 24px;
    height: 24px;
  }
  .welcomeMesg {
    font-size: 0.75rem;
  }
  .botMain {
    font-size: 0.9rem;
  }
  .botSub {
    font-size: 0.75rem;
  }
  .trademark {
    height: 6vh;
    padding: 0.6rem;
  }
  .widgetSubtext {
    font-size: 14px;
  }
  .req-label-form {
    font-size: 12px;
  }
  .startChatUser {
    margin-top: 16px;
  }
  .fillTxt {
    font-size: 14px;
    padding-bottom: 10px;
  }
  .widgetLogo {
    max-width: 60px;
    max-height: 56px;
  }
  .previewOneCenter {
    height: 38.943vh;
    justify-content: space-between;
    padding: 3rem 0 0.625rem 0;
  }
  .previewTwoCenter {
    height: 40.06vh;
  }
  .preChatForm {
    padding: 2rem 1rem;
  }
  .previewThreeCenter {
    height: 43vh !important;
  }
  .sidebar-widget-settings {
    min-width: 432px;
    max-height: 784px;
  }
  .main-widget-settings {
    min-width: 656px;
  }
  .boxTop {
    height: 15vh;
  }
  .form-input-div {
    min-height: 40px;
  }
  .preChatBtn {
    font-size: 0.8rem;
    min-height: 40px;
    padding: 0.6rem;
  }
  .chatSnap {
    height: 16vh;
  }
  .input-main-message {
    font-size: 14px;
  }
  .sidebar-widget-settings-tab {
    margin-bottom: 28px;
  }
  .welcomeText {
    padding-bottom: 12px;
  }
}

@media only screen and (min-width: 1920px) {
  .startChatUser {
    margin-top: 16px;
  }
  .fillTxt {
    font-size: 14px;
    padding-bottom: 10px;
  }
  .widgetLogo {
    max-width: 72px;
    max-height: 68px;
  }
  .chatSnap {
    height: auto;
  }
  .form-input-div {
    min-height: 40px;
  }
  .preChatBtn {
    min-height: 40px;
  }
  .boxTop {
    height: 15vh;
  }
  .previewOneCenter {
    height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 3rem 0 0.8rem 0;
  }
  .previewTwoCenter {
    height: 41vh;
  }
  .preChatForm {
    padding: 2rem 1rem;
  }
  .previewThreeCenter {
    height: 43vh !important;
  }
  .input-main-message {
    font-size: 14px !important;
  }
  .sidebar-widget-settings-tab {
    margin-bottom: 28px;
  }
  .welcomeText {
    padding-bottom: 12px;
  }
}

.chat-box-client-container {
  height: 58px;
  position: relative;
  width: 100%;
  bottom: 0;
  left: 0;
  border-top: 1px solid#F4F5F7;
  display: flex;
}
.input-main-message {
  font-family: "Arial", sans-serif;
  resize: none;
  border: none;
  padding: 20px;
  outline: none;
  background: #fff;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  border-radius: 0 0 8px 8px;
}
.input-icons-div {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  align-items: center;
  bottom: 10px;
  right: 10px;
}
.input-icons-div p {
  margin: 0;
  padding: 5px;
  cursor: pointer;
}

.label {
  text-decoration: none;
  text-underline-offset: 5px;
  cursor: pointer;
  color: inherit;
}

.label.picked {
  text-decoration: underline;
  text-decoration-color: #148dfd;
  color: #061522;
}

.Personal-Information-Main-Container {
  margin: 52px 0 140px 0;
}
.Personal-Information {
  margin: 15px auto;
  width: 552px;
}
.Notification-Main-Container {
  display: flex;
  flex-direction: row;
  padding: 24px;
  padding-right: 80px;
  padding-top: 40px;
  justify-content: space-between;
}
.notification-description {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-family: Inter;
  font-weight: 400;
  line-height: 18px;
}
.Personal-Info-Text-Container {
  padding-bottom: 35px;
}
.Personal-Info-Text {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  padding-bottom: 5px;
}
.Personal-Info-SubText {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.Avatar-Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 29px;
}
.Avatar-Text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.Avatar-Subtext {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.Avatar-Img-Main {
  display: flex;
  align-items: center;
  gap: 16px;
}
.Change-Avatar-Button {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  width: 128px;
  height: 40px;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}

.Spacing-Bottom {
  padding-bottom: 20px;
}
.Personal-Information-Inputs {
  padding-bottom: 20px;
}
.Personal-Information-Save-Button {
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  width: 152px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  float: right;
  cursor: pointer;
  border: 0;
}
.Personal-Information-Save-Button:not(:disabled):hover {
  background-color: #0077cc;

  outline: none;
}

/* Muted disabled (empty / invalid / unavailable) — outlined, light surface */
.Personal-Information-Save-Button:disabled {
  background: #f9fafb;
  color: #93a1b0;
  border: 1px solid #d5dce1;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

/* Keep primary fill while disabled+loading so the white spinner stays visible */
.Personal-Information-Save-Button--primary-loading:disabled {
  background: #148dfd;
  color: #fff;
  border: 0;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  cursor: wait;
  opacity: 1;
}
.Notification-Sound {
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 8px;
}
.Notification-Sounds {
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 48px;
  width: 552px;
}

.Notification-Sound-Row-One {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Override Material-UI defaults that might differ between environments */
.Notification-Sound-Row-One .MuiFormControlLabel-root {
  margin: 1px 0 0 0 !important; /* top right bottom left */
}

.Notification-Sound-Row-One .MuiSwitch-root {
  margin: 0 !important;
}

/* Consistent icon sizing */
.Notification-Sound-Row-One svg {
  width: 24px;
  height: 24px;
  display: block;
  flex-shrink: 0;
}

/* Text alignment */
.Notification-Sound-Text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin-left: 4px;

  display: inline-block;
}

.Notification-Sounds-Text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding-bottom: 14px;
}
.Notification-Sounds-Row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.Notification-Sounds-Row-Text {
  display: flex;
  margin-top: 11px;
}
.notification-checkbox {
  margin-left: 8px;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.export-btn {
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  width: 136px;
  height: 40px;
  color: #fff;
  text-transform: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  float: right;
  cursor: pointer;
  border: 0;
}

.export-btn:not(:disabled):hover {
  background-color: #0077cc;

  outline: none;
}
.Data-export-main-container {
  background: #ffffff;
  padding: 24px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.data-export-heading {
  color: #061522;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 0;
}
/* Dialog box */
.exportDialog .MuiPaper-root {
  border-radius: 8px;
  padding: 32px;
  width: 424px;
}

/* Review text */
.PopUp-Review-Text {
  font-size: 10px;
}

/* Export type margin */
.exportType-box {
  margin-top: 13px;
}

/* Select placeholder */
.select-placeholder {
  color: #405261;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
}

/* Custom select */
.custom-select {
  width: 360px;
  height: 40px;
  cursor: pointer;
  font-size: 14px;
  color: #405261;
}

.custom-select .MuiSelect-select {
  padding: 0px 12px;
}

/* Menu dropdown */
.custom-menu {
  border: 1px solid #d5dce1;
  margin-top: 4px;
  border-radius: 4px;
}

.custom-menu .MuiMenuItem-root {
  font-size: 14px;
  padding: 8px 12px;
  color: #556575;
  background-color: transparent !important;
}

.custom-menu .MuiMenuItem-root:hover {
  background-color: #f9fafa !important;
}

.custom-menu .MuiMenuItem-root.Mui-selected {
  color: #061522;
  background-color: #f9fafa !important;
}

/* Date picker */
.dateRange-wrapper {
  display: flex;
  gap: 8px;
}

.dateBox {
  position: relative;
  width: 176px;
}

.date-input {
  width: 176px;
}

.date-input .MuiInputBase-root {
  height: 40px;
  font-size: 14px;
  color: #405261;
}

.date-input .MuiInputBase-input {
  padding: 0px 12px;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
}

/* Calendar popper */
.custom-popper .MuiPaper-root {
  border: 1px solid #d5dce1;
  border-radius: 4px;
  margin-top: 4px;
}

.custom-popper .MuiPickersDay-root {
  font-size: 14px;
  color: #556575;
}

.custom-popper .MuiPickersDay-root:hover {
  background-color: #f9fafa;
}

.custom-popper .MuiPickersDay-root.Mui-selected {
  color: #061522;
  background-color: #f9fafa !important;
}

/* Footer */
.exportBtn-footer {
  display: flex;
  align-self: flex-end;
  margin-top: 48px;
  gap: 8px;
}

.exportBtn {
  width: 96px;
}
.exportBtn {
  width: 96px;
}
.exportBtn:hover:not(:disabled) {
  background: #f0f4f8;
}
/* Disabled style */
.exportBtn:disabled {
  border-radius: 8px;
  border: 1px solid #c5ced6;
  background: #f9fafa;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
  color: #a0aab4; /* optional: make text look disabled */
  cursor: not-allowed;
}

.notification-checkbox-nm {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.notification-checkbox-link {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #148dfd;
}
.notifications-wrapper {
  width: 100%;
  height: 100vh; /* Full visible viewport height */
  overflow: hidden; /* Prevent both vertical & horizontal scroll */
  display: flex;
  flex-direction: column;
  background: #fff;
}
.notification-checkbox-underline {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #061522;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.audienec-container {
  display: flex;

  padding-top: 12px;
}
.subscripe-main-container {
  border: 1px solid #d5dce1;
  padding: 24px;
  border-radius: 8px;
  background-color: #fff;
  padding-top: 37px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.plan-btn {
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-transform: none;
  cursor: pointer;
}

/* Hover state */
.plan-btn:not(.Mui-disabled):hover {
  background-color: #ffffff;
  border-color: #c5ced6;
}

/* Disabled state */
.plan-btn.Mui-disabled {
  color: #93a1b0;
  border: 1px solid #c5ced6;
  background-color: #f9fafa;
  cursor: not-allowed;
}
.plan-btn-main-container {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

@media (max-width: 1203px) {
  .Notification-Main-Container {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px; /* spacing between checkbox and dropdown */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/Settings/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,wCAAwC;;EAExC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;AACA;EACE;;;;GAIC;EACD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gCAAgC,EAAE,wBAAwB;AAC5D;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,oCAAoC;EACpC,kBAAkB,EAAE,uBAAuB;EAC3C,0BAA0B,EAAE,2CAA2C;EACvE,6CAA6C,EAAE,8BAA8B;AAC/E;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,kCAAkC;EAC7D,0BAA0B,EAAE,sDAAsD;AACpF;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB;uBACqB;EACrB,gBAAgB;EAChB,QAAQ;EACR,MAAM;AACR;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;;AAEA,6EAA6E;AAC7E;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,iDAAiD;EACjD,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,yEAAyE;AACzE;EACE,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;EAEhB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;;EAEzB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc,EAAE,sCAAsC;EACtD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa,EAAE,iCAAiC;EAChD,gBAAgB,EAAE,8CAA8C;EAChE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,aAAa;;EAEb,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;EACjD,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE;IACE,iCAAiC;IACjC,kCAAkC;IAClC,SAAS,EAAE,0CAA0C;EACvD;AACF","sourcesContent":[".cs-input {\n  width: 100%;\n  height: 40px;\n  border-radius: 8px;\n  outline: none;\n  border: 1px solid #d5dce1;\n}\n.cs-input:hover {\n  border-color: #a9b0b6;\n}\n.cs-input:focus {\n  border-color: #148dfd;\n  box-shadow: 0 0 2px #148dfd;\n}\n.cs-text {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.defaultColor {\n  background: #148dfd;\n  color: #fff;\n}\n.defaultTextColor {\n  color: #148dfd;\n}\n.widget-settings-tabs-container {\n  display: flex;\n  margin: 5px 0 27px 0;\n}\n.status-list {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.list-icon-hid {\n  visibility: hidden;\n}\n.offline-info-textarea::placeholder {\n  color: #c5ced6;\n  font-size: 14px;\n  line-height: 18px;\n}\n.installChatBox {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 16px 24px;\n  width: 100%;\n}\n.parInfo {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n.parInfoStart {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 18px;\n}\n.WidgetRoleAgentStatus {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 5px 5px 16px 5px;\n  width: 100%;\n}\n.installInfoText {\n  margin: 6px 0 0 0;\n  line-height: 28px;\n  font-size: 14px;\n}\n.settingsInfoTextTop {\n  margin: 10.8px 0 0 0;\n  line-height: 18px;\n  font-size: 14px;\n}\n.settingsInfoText {\n  margin: 18px 0 12px 0;\n  line-height: 22px;\n  font-size: 14px;\n}\n.Settings-Info-Container {\n  display: flex;\n  margin-top: 23px;\n  gap: 8px;\n}\n.Settings-Info-Container-Secondary {\n  display: flex;\n  gap: 8px;\n  width: 50%;\n  margin-right: 8px;\n  align-items: end;\n}\n.custom-color-picker {\n  display: flex;\n  gap: 8px;\n  align-items: end;\n}\n.halfWidth {\n  width: 50%;\n}\n.appearance-options {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n.color-options {\n  display: flex;\n  gap: 8px;\n  margin-top: 13px;\n  cursor: pointer;\n}\n.settings-tab-button {\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  height: 40px;\n  cursor: pointer;\n}\n.settings-tab-button:not(:disabled):hover {\n  background-color: #0077cc;\n\n  outline: none;\n}\n\n.apply-button {\n  min-width: 112px;\n  /* margin-top: 23px; */\n}\n.check-button {\n  min-width: 80px;\n  /* margin-top: 22px; */\n}\n.banner-cancel-button {\n  padding: 10px 20px;\n  background: transparent;\n  color: #405261;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  border: 1px solid #d5dce1;\n}\n.banner-cancel-button :not(:disabled):hover {\n  border: 1px solid #c5ced6 !important;\n  background-color: transparent !important;\n\n  outline: none;\n}\n.banner-save-button {\n  padding: 10px 20px;\n  font-weight: 500;\n  font-size: 14px;\n}\n.invite-dev-button {\n  min-width: 184px;\n  background: transparent;\n  color: #405261;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  border: 1px solid #d5dce1;\n}\n.invite-dev-button:not(:disabled):hover {\n  border: 1px solid #c5ced6;\n\n  outline: none;\n}\n.installation-guide-button {\n  min-width: 160px;\n  background: transparent;\n  color: #405261;\n  font-weight: 500;\n  border-radius: 8px;\n  font-size: 14px;\n  border: 1px solid #d5dce1;\n}\n.installation-guide-button:not(:disabled):hover {\n  border: 1px solid #c5ced6;\n\n  outline: none;\n}\n.copy-code-button {\n  min-width: 120px;\n  transition: opacity 0.3s ease;\n}\n.copy-code-button:active {\n  opacity: 0.8;\n}\n.codeContainer {\n  display: flex;\n  font-family: monospace;\n  font-size: 14px;\n  padding: 10px;\n  max-height: 280px;\n  overflow-y: scroll;\n}\n.codeContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n.codeContainer::scrollbar {\n  background: transparent !important;\n}\n.gradientback {\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) -9.78%,\n    #fff 58.22%\n  );\n  opacity: 0.8;\n  height: 80px;\n  margin-top: -80px;\n  width: 99%;\n  margin-bottom: 2.2rem;\n}\n.codeContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n.lineNumbers {\n  padding-right: 10px;\n  text-align: right;\n  color: #148dfd;\n  user-select: none;\n}\n.codeContent {\n  /* white-space: pre; */\n  color: #556575;\n}\n.lineNumber {\n  line-height: 1.5;\n}\n.codeLine {\n  line-height: 1.5;\n}\n.settings-logo-section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.settings-logo-text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n.settings-logo-requirements {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.sideSpacx {\n  max-width: 112px;\n}\n.bottomSpacx {\n  max-width: 113px;\n}\n.live-view-link {\n  color: #148dfd;\n  font-size: 14px;\n}\n.welcomeMsg {\n  display: flex;\n  margin-top: 23px;\n  gap: 16px;\n}\n.showSettingsContainer {\n  margin-top: 20px;\n  margin-bottom: 1rem;\n}\n.preChatContainer {\n  margin-top: 23px;\n}\n.Settings-Appearance-Container {\n  margin-top: 20px;\n}\n.Settings-Appearance-Container-Secondary {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n.Settings-Visibility-Container {\n  margin-top: 22px;\n}\n.Settings-Visibility-Container-Secondary {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n}\n.spacingInputs {\n  width: 50%;\n  display: flex;\n  gap: 18px;\n  margin-top: 6px;\n}\n.spacingUnits {\n  margin-top: 18px;\n  font-size: 14px;\n  color: #405261;\n}\n.Settings-Language-Container {\n  margin-top: 18px;\n}\n.label-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.form-name {\n  margin-bottom: 8px;\n}\n.form-input-div {\n  margin-top: 5px;\n  border-radius: 8px;\n  background: transparent;\n  padding: 0.5rem;\n  /* min-height: 1.5rem; */\n  /* font-size: 0.875rem; */\n  border: 1px solid rgb(216, 220, 222);\n  width: 100%;\n}\n.input-spacing {\n  margin-bottom: 10px;\n}\n.settingsInfo {\n  width: 42%;\n}\n.installChat {\n  margin-top: 29.2px;\n}\n.startChat {\n  margin-top: 23px;\n}\n.Setting-Section-Logo {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 23px;\n}\n.custom-border {\n  border-color: #d5dce1 !important; /* Custom border color */\n}\n.Settings-Line-Bottom {\n  margin: 24px 0 20px 0;\n  width: 100%;\n  height: 1px;\n  border: 1px solid #e5e9ec;\n}\n.Install-Line-Bottom {\n  margin: 10px 0 0 0;\n  width: 100%;\n  height: 1px;\n  border: 1px solid #e5e9ec;\n}\n.Settings-Line-Bottom-Welcome {\n  margin: 34px 0;\n  width: 100%;\n  height: 1px;\n  border: 1px solid #e5e9ec;\n}\n.Appearance-button {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 56px;\n  background: none;\n  border: 1px solid #e5e9ec;\n  border-radius: 8px;\n  font-size: 14px;\n}\n.Appearance-button.active {\n  background-color: #f3fbff;\n  border: 1px solid #148dfd;\n}\n.margin-left {\n  margin-left: 7px;\n}\n.margin-right {\n  margin-right: 7px;\n}\n.custom-tab {\n  padding: 8px 0;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 18px;\n  color: #405261;\n  text-transform: none;\n  border: none;\n  background-color: transparent;\n  outline: none;\n  border-bottom: 1px solid transparent;\n  margin-right: 20px; /* Space between tabs */\n  border-radius: 4px 4px 0 0; /* Rounded corners at the top of the tabs */\n  transition: background-color 0.3s, color 0.3s; /* Smooth transition effects */\n}\n.custom-tab.selected {\n  color: #061522;\n  font-weight: 500;\n  border-bottom: 1px solid #1976d2;\n}\n\n.custom-tab-content {\n  padding: 16px;\n  border: 1px solid #e0e0e0; /* Border around the tab content */\n  border-radius: 0 0 4px 4px; /* Rounded corners at the bottom of the content area */\n}\n\n.sidebar-widget-settings {\n  border: 1px solid#E5E9EC;\n  padding: 8px 15px;\n  background: #f9fafa;\n  border-radius: 8px;\n  /* overflow-y: auto;\n  overflow-x: hidden; */\n  position: sticky;\n  right: 0;\n  top: 0;\n}\n.main-widget-settings {\n  border: 1px solid#E5E9EC;\n  /* max-width: 656px; */\n  width: 72%;\n  padding: 10px 23px;\n  border-radius: 8px;\n  height: fit-content;\n  /* margin-bottom: 3rem; */\n}\n.previewOneCenter {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  height: 28vh;\n}\n.boxTop {\n  height: 10vh;\n}\n.widgetLogo {\n  max-height: 35px;\n  border-radius: 50%;\n}\n.chatSnap {\n  height: 10vh;\n}\n.preChatForm {\n  padding: 1rem;\n}\n.sidebar-widget-settings-tab {\n  margin-bottom: 10px;\n}\n.fillTxt {\n  font-size: 0.7rem;\n}\n.startChatUser {\n  margin-top: 10px;\n}\n@media screen and (max-width: 1280px) {\n  .sidebar-widget-settings {\n    height: calc(100vh - 13em);\n    width: 28%;\n  }\n  .previewOneCenter {\n    height: 24vh;\n  }\n  .fillTxt {\n    display: none;\n  }\n  .preChatForm {\n    padding: 0.5rem;\n  }\n  .welcomeText {\n    font-size: 0.75rem;\n    padding-bottom: 5px;\n  }\n  .form-input-div {\n    font-size: 0.6rem;\n  }\n  .widgetSubtext {\n    font-size: 0.6rem;\n  }\n  .input-main-message {\n    font-size: 0.6rem;\n  }\n  .preChatBtn {\n    font-size: 0.6rem;\n  }\n  .barText {\n    font-size: 0.6rem;\n  }\n  .botMain {\n    font-size: 0.75rem;\n  }\n  .botSub {\n    font-size: 0.6rem;\n  }\n  .welcomeMesg {\n    font-size: 0.6rem;\n  }\n  .input-icons-div img {\n    width: 18px;\n    height: 18px;\n  }\n  .bubble {\n    width: 39px;\n    height: 39px;\n  }\n  .bar {\n    height: 39px;\n  }\n  .trademark {\n    visibility: hidden;\n    padding: 0.01rem;\n  }\n  .widgetLogo {\n    max-height: 34px;\n  }\n  .req-label-form {\n    font-size: 0.6rem;\n  }\n}\n@media screen and (min-width: 1281px) and (max-height: 850px) {\n  .sidebar-widget-settings {\n    height: calc(100vh - 13em);\n    width: 32%;\n  }\n  .previewOneCenter {\n    height: 30vh;\n  }\n  .previewThreeCenter {\n    height: 36vh !important;\n  }\n  .chatSnap {\n    height: 12vh;\n  }\n  .welcomeText {\n    font-size: 14px;\n  }\n  .form-input-div {\n    font-size: 0.8rem;\n  }\n  .widgetSubtext {\n    font-size: 14px;\n  }\n  .input-main-message {\n    font-size: 0.75rem;\n  }\n  .preChatBtn {\n    font-size: 0.8rem;\n    min-height: 32px;\n  }\n  .trademark {\n    height: 6vh;\n    padding: 0.6rem;\n  }\n  .botMain {\n    font-size: 0.9rem;\n  }\n  .botSub {\n    font-size: 0.75rem;\n  }\n  .welcomeMesg {\n    font-size: 0.75rem;\n  }\n  .input-icons-div img {\n    width: 24px;\n    height: 24px;\n  }\n  .bubble {\n    width: 56px;\n    height: 56px;\n  }\n  .bar {\n    height: 56px;\n  }\n  .fillTxt {\n    display: block;\n  }\n  .req-label-form {\n    font-size: 0.6rem;\n  }\n}\n@media screen and (max-width: 1430px) {\n  .widgetSubtext {\n    font-size: 0.6rem;\n  }\n  .custom-tab-sidebar {\n    font-size: 12px;\n  }\n  .live-view-link {\n    font-size: 12px;\n  }\n  .preChatBtn {\n    padding: 0.45rem;\n  }\n}\n@media screen and (min-width: 1430px) and (min-height: 850px) {\n  .bubble {\n    width: 56px;\n    height: 56px;\n  }\n  .bar {\n    height: 56px;\n  }\n  .input-icons-div img {\n    width: 24px;\n    height: 24px;\n  }\n  .welcomeMesg {\n    font-size: 0.75rem;\n  }\n  .botMain {\n    font-size: 0.9rem;\n  }\n  .botSub {\n    font-size: 0.75rem;\n  }\n  .trademark {\n    height: 6vh;\n    padding: 0.6rem;\n  }\n  .widgetSubtext {\n    font-size: 14px;\n  }\n  .req-label-form {\n    font-size: 12px;\n  }\n  .startChatUser {\n    margin-top: 16px;\n  }\n  .fillTxt {\n    font-size: 14px;\n    padding-bottom: 10px;\n  }\n  .widgetLogo {\n    max-width: 60px;\n    max-height: 56px;\n  }\n  .previewOneCenter {\n    height: 38.943vh;\n    justify-content: space-between;\n    padding: 3rem 0 0.625rem 0;\n  }\n  .previewTwoCenter {\n    height: 40.06vh;\n  }\n  .preChatForm {\n    padding: 2rem 1rem;\n  }\n  .previewThreeCenter {\n    height: 43vh !important;\n  }\n  .sidebar-widget-settings {\n    min-width: 432px;\n    max-height: 784px;\n  }\n  .main-widget-settings {\n    min-width: 656px;\n  }\n  .boxTop {\n    height: 15vh;\n  }\n  .form-input-div {\n    min-height: 40px;\n  }\n  .preChatBtn {\n    font-size: 0.8rem;\n    min-height: 40px;\n    padding: 0.6rem;\n  }\n  .chatSnap {\n    height: 16vh;\n  }\n  .input-main-message {\n    font-size: 14px;\n  }\n  .sidebar-widget-settings-tab {\n    margin-bottom: 28px;\n  }\n  .welcomeText {\n    padding-bottom: 12px;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .startChatUser {\n    margin-top: 16px;\n  }\n  .fillTxt {\n    font-size: 14px;\n    padding-bottom: 10px;\n  }\n  .widgetLogo {\n    max-width: 72px;\n    max-height: 68px;\n  }\n  .chatSnap {\n    height: auto;\n  }\n  .form-input-div {\n    min-height: 40px;\n  }\n  .preChatBtn {\n    min-height: 40px;\n  }\n  .boxTop {\n    height: 15vh;\n  }\n  .previewOneCenter {\n    height: 40vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding: 3rem 0 0.8rem 0;\n  }\n  .previewTwoCenter {\n    height: 41vh;\n  }\n  .preChatForm {\n    padding: 2rem 1rem;\n  }\n  .previewThreeCenter {\n    height: 43vh !important;\n  }\n  .input-main-message {\n    font-size: 14px !important;\n  }\n  .sidebar-widget-settings-tab {\n    margin-bottom: 28px;\n  }\n  .welcomeText {\n    padding-bottom: 12px;\n  }\n}\n\n.chat-box-client-container {\n  height: 58px;\n  position: relative;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  border-top: 1px solid#F4F5F7;\n  display: flex;\n}\n.input-main-message {\n  font-family: \"Arial\", sans-serif;\n  resize: none;\n  border: none;\n  padding: 20px;\n  outline: none;\n  background: #fff;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  border-radius: 0 0 8px 8px;\n}\n.input-icons-div {\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  align-items: center;\n  bottom: 10px;\n  right: 10px;\n}\n.input-icons-div p {\n  margin: 0;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.label {\n  text-decoration: none;\n  text-underline-offset: 5px;\n  cursor: pointer;\n  color: inherit;\n}\n\n.label.picked {\n  text-decoration: underline;\n  text-decoration-color: #148dfd;\n  color: #061522;\n}\n\n.Personal-Information-Main-Container {\n  margin: 52px 0 140px 0;\n}\n.Personal-Information {\n  margin: 15px auto;\n  width: 552px;\n}\n.Notification-Main-Container {\n  display: flex;\n  flex-direction: row;\n  padding: 24px;\n  padding-right: 80px;\n  padding-top: 40px;\n  justify-content: space-between;\n}\n.notification-description {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-family: Inter;\n  font-weight: 400;\n  line-height: 18px;\n}\n.Personal-Info-Text-Container {\n  padding-bottom: 35px;\n}\n.Personal-Info-Text {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  padding-bottom: 5px;\n}\n.Personal-Info-SubText {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.Avatar-Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 29px;\n}\n.Avatar-Text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.Avatar-Subtext {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.Avatar-Img-Main {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.Change-Avatar-Button {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  width: 128px;\n  height: 40px;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n\n.Spacing-Bottom {\n  padding-bottom: 20px;\n}\n.Personal-Information-Inputs {\n  padding-bottom: 20px;\n}\n.Personal-Information-Save-Button {\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  width: 152px;\n  height: 40px;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  float: right;\n  cursor: pointer;\n  border: 0;\n}\n.Personal-Information-Save-Button:not(:disabled):hover {\n  background-color: #0077cc;\n\n  outline: none;\n}\n\n/* Muted disabled (empty / invalid / unavailable) — outlined, light surface */\n.Personal-Information-Save-Button:disabled {\n  background: #f9fafb;\n  color: #93a1b0;\n  border: 1px solid #d5dce1;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n/* Keep primary fill while disabled+loading so the white spinner stays visible */\n.Personal-Information-Save-Button--primary-loading:disabled {\n  background: #148dfd;\n  color: #fff;\n  border: 0;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  cursor: wait;\n  opacity: 1;\n}\n.Notification-Sound {\n  padding: 24px;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  box-sizing: border-box;\n  margin-bottom: 8px;\n}\n.Notification-Sounds {\n  padding: 24px;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  box-sizing: border-box;\n  margin-bottom: 48px;\n  width: 552px;\n}\n\n.Notification-Sound-Row-One {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Override Material-UI defaults that might differ between environments */\n.Notification-Sound-Row-One .MuiFormControlLabel-root {\n  margin: 1px 0 0 0 !important; /* top right bottom left */\n}\n\n.Notification-Sound-Row-One .MuiSwitch-root {\n  margin: 0 !important;\n}\n\n/* Consistent icon sizing */\n.Notification-Sound-Row-One svg {\n  width: 24px;\n  height: 24px;\n  display: block;\n  flex-shrink: 0;\n}\n\n/* Text alignment */\n.Notification-Sound-Text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  margin-left: 4px;\n\n  display: inline-block;\n}\n\n.Notification-Sounds-Text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  padding-bottom: 14px;\n}\n.Notification-Sounds-Row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.Notification-Sounds-Row-Text {\n  display: flex;\n  margin-top: 11px;\n}\n.notification-checkbox {\n  margin-left: 8px;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.export-btn {\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  width: 136px;\n  height: 40px;\n  color: #fff;\n  text-transform: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  float: right;\n  cursor: pointer;\n  border: 0;\n}\n\n.export-btn:not(:disabled):hover {\n  background-color: #0077cc;\n\n  outline: none;\n}\n.Data-export-main-container {\n  background: #ffffff;\n  padding: 24px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n.data-export-heading {\n  color: #061522;\n  font-family: \"Inter\", sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 20px;\n  margin-bottom: 0;\n}\n/* Dialog box */\n.exportDialog .MuiPaper-root {\n  border-radius: 8px;\n  padding: 32px;\n  width: 424px;\n}\n\n/* Review text */\n.PopUp-Review-Text {\n  font-size: 10px;\n}\n\n/* Export type margin */\n.exportType-box {\n  margin-top: 13px;\n}\n\n/* Select placeholder */\n.select-placeholder {\n  color: #405261;\n  font-size: 14px;\n  font-family: Inter;\n  font-weight: 400;\n}\n\n/* Custom select */\n.custom-select {\n  width: 360px;\n  height: 40px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #405261;\n}\n\n.custom-select .MuiSelect-select {\n  padding: 0px 12px;\n}\n\n/* Menu dropdown */\n.custom-menu {\n  border: 1px solid #d5dce1;\n  margin-top: 4px;\n  border-radius: 4px;\n}\n\n.custom-menu .MuiMenuItem-root {\n  font-size: 14px;\n  padding: 8px 12px;\n  color: #556575;\n  background-color: transparent !important;\n}\n\n.custom-menu .MuiMenuItem-root:hover {\n  background-color: #f9fafa !important;\n}\n\n.custom-menu .MuiMenuItem-root.Mui-selected {\n  color: #061522;\n  background-color: #f9fafa !important;\n}\n\n/* Date picker */\n.dateRange-wrapper {\n  display: flex;\n  gap: 8px;\n}\n\n.dateBox {\n  position: relative;\n  width: 176px;\n}\n\n.date-input {\n  width: 176px;\n}\n\n.date-input .MuiInputBase-root {\n  height: 40px;\n  font-size: 14px;\n  color: #405261;\n}\n\n.date-input .MuiInputBase-input {\n  padding: 0px 12px;\n  font-size: 14px;\n  font-family: Inter;\n  font-weight: 400;\n}\n\n/* Calendar popper */\n.custom-popper .MuiPaper-root {\n  border: 1px solid #d5dce1;\n  border-radius: 4px;\n  margin-top: 4px;\n}\n\n.custom-popper .MuiPickersDay-root {\n  font-size: 14px;\n  color: #556575;\n}\n\n.custom-popper .MuiPickersDay-root:hover {\n  background-color: #f9fafa;\n}\n\n.custom-popper .MuiPickersDay-root.Mui-selected {\n  color: #061522;\n  background-color: #f9fafa !important;\n}\n\n/* Footer */\n.exportBtn-footer {\n  display: flex;\n  align-self: flex-end;\n  margin-top: 48px;\n  gap: 8px;\n}\n\n.exportBtn {\n  width: 96px;\n}\n.exportBtn {\n  width: 96px;\n}\n.exportBtn:hover:not(:disabled) {\n  background: #f0f4f8;\n}\n/* Disabled style */\n.exportBtn:disabled {\n  border-radius: 8px;\n  border: 1px solid #c5ced6;\n  background: #f9fafa;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n  color: #a0aab4; /* optional: make text look disabled */\n  cursor: not-allowed;\n}\n\n.notification-checkbox-nm {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.notification-checkbox-link {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  color: #148dfd;\n}\n.notifications-wrapper {\n  width: 100%;\n  height: 100vh; /* Full visible viewport height */\n  overflow: hidden; /* Prevent both vertical & horizontal scroll */\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n.notification-checkbox-underline {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  color: #061522;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n.audienec-container {\n  display: flex;\n\n  padding-top: 12px;\n}\n.subscripe-main-container {\n  border: 1px solid #d5dce1;\n  padding: 24px;\n  border-radius: 8px;\n  background-color: #fff;\n  padding-top: 37px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.plan-btn {\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  background-color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  text-transform: none;\n  cursor: pointer;\n}\n\n/* Hover state */\n.plan-btn:not(.Mui-disabled):hover {\n  background-color: #ffffff;\n  border-color: #c5ced6;\n}\n\n/* Disabled state */\n.plan-btn.Mui-disabled {\n  color: #93a1b0;\n  border: 1px solid #c5ced6;\n  background-color: #f9fafa;\n  cursor: not-allowed;\n}\n.plan-btn-main-container {\n  margin-top: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n}\n\n@media (max-width: 1203px) {\n  .Notification-Main-Container {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 10px; /* spacing between checkbox and dropdown */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
